import styled from 'styled-components';
import { Border, BorderRadius, BoxShadow, Colors } from 'web-common/src/shared/styles';

export const PanelCard = styled.div`
  border: ${Border.Base} ${Colors.GRAY_LITE_20};
  border-radius: ${BorderRadius.M};
  box-shadow: ${BoxShadow.HOMEPAGE_HERO_CONTENT};
  width: 100%;
`;
